import { FC, ReactNode } from "react"

interface SectionCardProps {
  title: string
  description?: string
  children: ReactNode
}

export const SectionCard: FC<SectionCardProps> = ({ title, description, children }) => (
  <div className="flex flex-col gap-4 px-4 py-4 border rounded-lg border-black/10 dark:border-white/10 bg-white dark:bg-[#0C0C1A]">
    <p className="text-base font-semibold text-gray-800 dark:text-white">{title}</p>
    {description && <p className="text-xs text-gray-500 dark:text-gray-400 -mt-2">{description}</p>}
    {children}
  </div>
)
